import React, { createClass, PropTypes } from 'react';

const TextArea = createClass({

  propTypes: {
    onChange: PropTypes.func,
    style: PropTypes.object,
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.string,
    rows: PropTypes.number,
  },

  handleChange(event) {
    if (this.props.onChange) this.props.onChange(event);
  },

  render() {
    return (
      <div className="textarea-container">
        <textarea
          style={this.props.style}
          name={this.props.name}
          id={this.props.id}
          value={this.props.value}
          defaultValue={this.props.defaultValue}
          onChange={this.handleChange}
          rows={this.props.rows}
          required={this.props.required}
        />
        {this.props.error ? <div className="error-message">{this.props.error}</div> : undefined}
      </div>
    );
  },
});

export default TextArea;



// WEBPACK FOOTER //
// ./src/app/components/textarea.jsx